import { Routes } from '@angular/router';

export const ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./+account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'stories',
    loadChildren: () => import('./+stories/stories.module').then(m => m.StoriesModule),
  },
  {
    path: 'projects',
    loadChildren: () => import('./+projects/projects.module').then(m => m.ProjectsModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./+profile/profile.module').then(m => m.ProfileModule),
  },
  { path: '**', redirectTo: 'stories' },
];
